<template>
  <div>

    <vs-table stripe :data="dataLocal" noDataText="暂无规则">
      <template slot="header">
        <div class="w-full mb-2 flex items-center justify-between">
          <h4>规则</h4>
          <vs-button color="success" size="small" @click="add">添加</vs-button>
        </div>
      </template>
      <template slot="thead">
        <vs-th width="80">充值(元)</vs-th>
        <vs-th width="80">赠金(元)</vs-th>
        <vs-th width="80">赠金(%)</vs-th>
        <vs-th width="80">流水(元)</vs-th>
        <vs-th width="60">
          <div class="text-center w-full">操作</div>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(item, index) in dataLocal" >
          <vs-td :data="item.recharge">
            <vs-input class="w-full" v-model="dataLocal[index].recharge" />
          </vs-td>
          <vs-td :data="item.coinFixed">
            <vs-input class="w-full" v-model="dataLocal[index].coinFixed" />
          </vs-td>
          <vs-td :data="item.coinPercent">
            <vs-input class="w-full" v-model="dataLocal[index].coinPercent" />
          </vs-td>
          <vs-td :data="item.limit">
            <vs-input class="w-full" v-model="dataLocal[index].limit" />
          </vs-td>
          <vs-td>
            <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="del" :data-index="index">删除</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: []
    }
  },
  methods: {
    del(e) {
      this.dataLocal.splice(e.currentTarget.dataset.index, 1)
    },
    add() {
      this.dataLocal.push({})
    },
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
